import { render } from "./returBlank.vue?vue&type=template&id=06613d6c"
import script from "./returBlank.vue?vue&type=script&lang=js"
export * from "./returBlank.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myWorkspace\\CoreWeb\\MyNews\\ClientApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__